import request from "@/utils/request";
// 获取小区(组)列表
export function GetRegionPage (params) {
  return request({
    url: "system/tregion/list",
    method: "get",
    params,
  });
}
// 获取楼栋列表
export function GetBuildPage (params) {
  return request({
    url: "system/tbuild/list",
    method: "get",
    params,
  });
}
// 获取单元列表
export function GetBuildUnitPage (params) {
  return request({
    url: "system/tbuildunit/list",
    // /system/tbuildunit/list
    method: "get",
    params,
  });
}
// 获取房屋列表
export function GetResidentPage (params) {
  return request({
    url: "system/tresident/list",
    method: "get",
    params,
  });
}
// 获取住户列表
export function GetResidentListByFamily (params) {
  return request({
    url: "system/tresident/list",
    method: "get",
    params,
  });
}
// 获取住户列表
export function GetBuildRoomPage (params) {
  return request({
    url: "Build/GetBuildRoomPage",
    method: "get",
    params,
  });
}
// 获取住户列表
export function GetBuildFamilyPage (params) {
  return request({
    url: "system/tbuildfamily/list",
    method: "get",
    params,
  });
}
//
export function GetBuildFamilyList (params) {
  return request({
    url: "system/tbuildfamily/list",
    method: "get",
    params,
  });
}
// 获取住户详情
export function GetResident (id) {
  return request({
    url: "system/tresident/" + id,
    method: "get",
  });
}
// 获取字典别表
export function GetCodeEntrysList (params) {
  // return request({
  //   url: "Code/GetCodeEntrysList",
  //   method: "get",
  //   params,
  // });
  return request({
    url: 'system/dict/data/type/' + params,
    method: 'get',
  })
}
// 保存指定家庭的住户信息
export function SaveResidentOfFamily (data) {
  return request({
    url: "system/tresident",
    method: "post",
    data,
  });
}
// 获取小区(组)别表
export function GetRegionInfo (params) {
  return request({
    url: "Region/GetRegionInfo",
    method: "get",
    params,
  });
}
// 保存小区(组)信息
export function SaveRegion (data) {
  return request({
    url: "Region/SaveRegion",
    method: "post",
    data,
  });
}
//获取小区(组)列表(下拉菜单)
export function WeGetRegionList (params) {
  return request({
    url: "Region/WeGetRegionList",
    method: "get",
    params,
  });
}
//获取小区(组)列表(下拉菜单)
export function GetRegionList (params) {
  return request({
    url: "system/tregion/list",
    method: "get",
    params,
  });
}
//获取楼栋列表(下拉菜单)
export function WeGetBuildList (params) {
  return request({
    url: "Build/WeGetBuildList",
    method: "get",
    params,
  });
}
// 楼栋
export function GetBuildList (params) {
  return request({
    url: "system/tbuild/list",
    // system/tbuild/list
    method: "get",
    params,
  });
}
//获取单元列表(下拉菜单)
export function WeGetBuildUnitList (params) {
  return request({
    url: "Build/WeGetBuildUnitList",
    method: "get",
    params,
  });
}
// 单元
export function GetBuildUnitList (params) {
  return request({
    url: "system/tbuildunit/list",
    // system/tbuildunit/list
    method: "get",
    params,
  });
}
// 删除住户信息
export function DeleteResident (id) {
  return request({
    url: "system/tresident/" + id,
    method: "delete",
  });
}
// 保存家庭信息
export function SaveBuildFamily (data) {
  return request({
    url: "system/tbuildfamily",
    method: "post",
    data,
  });
}
//获取家庭
export function GetBuildFamily (id) {
  return request({
    url: "system/tbuildfamily/" + id,
    method: "get",
  });
}
//地图获取房屋列表
export function GetBuildRoomList (BUId) {
  return request({
    url: "system/gridmanage/report/countByUnit?BUId=" + BUId,
    // /system/gridmanage/report/countByUnit?BUId=15415
    // /system/gridmanage/report/countByUnit?BUId=15415
    method: "get",
    // params,
  });
}
//根据楼栋id返回楼栋地图数据
export function GetBuildInfo (BId) {
  return request({
    url: "system/tbuild/" + BId,
    // /dev-api/system/tbuild/{BId}
    method: "get",
    // params,
  });
}
// 保存特困人员供养信息
export function SaveHPovertyStricken (data) {
  return request({
    url: "system/thpoverty",
    method: "post",
    data,
  });
}
// 保存低保人员信息
export function SaveHLower (data) {
  return request({
    url: "system/thlower",
    method: "post",
    data,
  });
}
// 保存廉租房人员信息
export function SaveHLowRent (data) {
  return request({
    url: "system/thlowrent",
    method: "post",
    data,
  });
}
// 保存特抚人员信息
export function SaveHSpecialHelper (data) {
  return request({
    url: "system/thspecialhelper",
    method: "post",
    data,
  });
}
// 保存党员信息
export function SaveHPartMember (data) {
  return request({
    url: "system/thpartmember",
    method: "post",
    data,
  });
}
// 保存残疾人信息
export function SaveHDisabled (data) {
  return request({
    url: "system/thdisabled",
    method: "post",
    data,
  });
}
// 保存退役军人信息
export function SaveHVeterans (data) {
  return request({
    url: "system/thveterans",
    method: "post",
    data,
  });
}
// 保存在校生信息
export function SaveHStudent (data) {
  return request({
    url: "Resident/SaveHStudent",
    method: "post",
    data,
  });
}
// 保存信访人员信息
export function SaveHLetterVisits (data) {
  return request({
    url: "system/thlettervisits",
    method: "post",
    data,
  });
}
// 保存矫正人员信息
export function SaveHCorrect (data) {
  return request({
    url: "system/thcorrect",
    method: "post",
    data,
  });
}
// 保存刑满释放人员信息
export function SaveHRelease (data) {
  return request({
    url: "system/threlease",
    method: "post",
    data,
  });
}
// 保存优抚人员信息
export function SaveHPriorHelper (data) {
  return request({
    url: "system/thpriorhelper",
    method: "post",
    data,
  });
}
// 保存吸毒人员信息
export function SaveHDruger (data) {
  return request({
    url: "system/thdruger",
    method: "post",
    data,
  });
}
// 保存邪教人员信息
export function SaveHCults (data) {
  return request({
    url: "system/thcults",
    method: "post",
    data,
  });
}
//商铺信息列表
export function GetShopPage (params) {
  return request({
    url: "system/tshop/list",
    method: "get",
    params,
  });
}
//根据房号获取商铺信息列表
export function GetShopByRridList (params) {
  return request({
    url: "system/tshop/list",
    method: "get",
    params,
  });
}
// 房屋与商铺信息绑定
export function RoomBindShop (params) {
  return request({
    url: "system/tshop/binding",
    method: "get",
    params,
  });
}
//楼层列表
export function WeGetBuildFloorList (params) {
  return request({
    url: "system/tbuildfloor/list",
    method: "get",
    params,
  });
}

//房间号列表
export function WeGetBuildRoomList (params) {
  return request({
    url: "system/tbuildroom/list",
    method: "get",
    params,
  });
}

//疫苗接种排查分页列表
export function GetCheckPage (params) {
  return request({
    url: "Vaccine/GetCheckPage",
    method: "get",
    params,
  });
}
//返洛分页列表
export function GetReportingPage (params) {
  return request({
    url: "Vaccine/GetReportingPage",
    method: "get",
    params,
  });
}

//离洛分页列表
export function GetOutReportingPage (params) {
  return request({
    url: "Vaccine/GetOutReportingPage",
    method: "get",
    params,
  });
}

//隔离人员分页列表
export function GetIsolationPage (params) {
  return request({
    url: "Isolation/GetIsolationPage",
    method: "get",
    params,
  });
}

// 确认返洛人员
export function ConfirmReporting (data) {
  return request({
    url: "Vaccine/ConfirmReporting",
    method: "post",
    data,
  });
}

// 添加管控人员
export function AddIsolation (data) {
  return request({
    url: "Isolation/AddIsolation",
    method: "post",
    data,
  });
}
//获取返淇人员报备详情
export function GetReporting (params) {
  return request({
    url: "Vaccine/GetReporting",
    method: "get",
    params,
  });
}
//获取返淇人员报备详情
export function WxGetReporting (params) {
  return request({
    url: "Vaccine/WxGetReporting",
    method: "get",
    params,
  });
}

//获取我的巡访区域关系信息
export function WeGetPatrolareaPage (params) {
  return request({
    url: "Patrolarea/WeGetPatrolareaPage",
    method: "get",
    params,
  });
}
